'use client';

import { createContext, useContext } from 'react';

import type { PreviewCoupon } from '../../functions/applyCouponsToUnitPrice';

export interface CouponPreviewContextValue {
  /** The previewed coupon (from `?coupon=`), or null when none / still loading. */
  coupon: PreviewCoupon | null;
}

/**
 * Shares the PDP's display-only coupon preview (resolved from `?coupon=XXX`)
 * with the price cell + Buy CTA, so both show the same coupon-discounted price.
 * Absent provider (or no coupon) → no preview, callers render the normal price.
 */
export const CouponPreviewContext =
  createContext<CouponPreviewContextValue | null>(null);

/** Read the previewed coupon; `null` outside the provider or when none applies. */
export function useCouponPreviewCoupon(): PreviewCoupon | null {
  return useContext(CouponPreviewContext)?.coupon ?? null;
}
